export default __webpack_public_path__ + "static/media/frame-pic2.5306c779.png";